import { ApiConfig } from "../../Config/ApiConfig";
import { CMS_GET,CMS_UPDATE } from "../../Constants/CmsConstants";
import { createPostDataAction } from "./CommonAction";

export const CmsGetAction = (payload: any) => createPostDataAction(CMS_GET, ApiConfig?.CmsPageGet, payload, false);
export const CmsDetailsAction = (payload: any) => createPostDataAction(CMS_GET, ApiConfig?.CmsDetails, payload, false);
export const CmsUpdateAction = (payload: any) => createPostDataAction(CMS_UPDATE, ApiConfig?.CmsUpdate, payload, true);




